let instance: AudioContext | null = null

type AudioContextCtor = typeof AudioContext

function resolveCtor(): AudioContextCtor | null {
  if (typeof window === 'undefined') return null
  const w = window as Window & { webkitAudioContext?: AudioContextCtor }
  return window.AudioContext ?? w.webkitAudioContext ?? null
}

export function getAudioContext(): AudioContext {
  if (instance) return instance
  const Ctor = resolveCtor()
  if (!Ctor) {
    throw new Error('Web Audio API is not available in this environment')
  }
  instance = new Ctor()
  return instance
}

export async function resumeAudioContext(): Promise<void> {
  const ctx = getAudioContext()
  if (ctx.state === 'suspended') {
    await ctx.resume()
  }
}

// Test-only reset; never call from production code.
export function _resetAudioContextForTests(): void {
  instance = null
}
